module.exports = __webpack_public_path__ + "static/media/delete.da20557c.svg";